(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sw-news-ribbon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sw-news-ribbon')) {
  customElements.define('sw-news-ribbon', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.items = [...this.querySelector('.sw-news__group').children];
      if (!this.items.length) return;
      this.index = 0;
      this.focused = false;
      this.hovered = false;
      this.classList.remove('is-focused', 'is-hovered');
      this.mobile = matchMedia('(max-width: 768px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      const options = { signal:this.abort.signal };
      this.pauseButton = this.querySelector('.sw-news__pause');
      this.querySelector('.sw-news__next').addEventListener('click', () => this.move(1, true), options);
      this.querySelector('.sw-news__previous').addEventListener('click', () => this.move(-1, true), options);
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); }, options);
      const newsWindow = this.querySelector('.sw-news__window');
      newsWindow.addEventListener('focusin', () => { this.focused = true; this.classList.add('is-focused'); }, options);
      newsWindow.addEventListener('focusout', () => { this.focused = false; this.classList.remove('is-focused'); }, options);
      newsWindow.addEventListener('mouseenter', () => { this.hovered = true; this.classList.add('is-hovered'); }, options);
      newsWindow.addEventListener('mouseleave', () => { this.hovered = false; this.classList.remove('is-hovered'); }, options);
      this.reduced.addEventListener('change', () => { this.paused = this.reduced.matches; this.updatePause(); }, options);
      this.items[0].classList.add('is-current');
      this.classList.add('is-ready');
      this.updatePause();
      window.addEventListener('pagehide', () => clearInterval(this.timer), options);
      window.addEventListener('pageshow', () => this.restore(), options);
      this.startTimer();
    }
    startTimer() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.mobile.matches && !this.paused && !this.focused && !this.hovered && !document.hidden) this.move(1, false);
      }, 8000);
    }
    restore() {
      // History restoration may retain a clicked link's focus/hover without new events.
      // Reset only these temporary stops; keep an intentional Pause and reduced motion.
      this.focused = false;
      this.hovered = false;
      this.classList.remove('is-focused', 'is-hovered');
      this.updatePause();
      this.startTimer();
      if (!this.paused && !this.reduced.matches) {
        this.querySelector('.sw-news__track').getAnimations().forEach((animation) => animation.play());
      }
    }
    move(direction, manual) {
      this.items[this.index].classList.remove('is-current');
      this.index = (this.index + direction + this.items.length) % this.items.length;
      this.items[this.index].classList.add('is-current');
      if (manual) { this.paused = true; this.updatePause(); }
    }
    updatePause() {
      this.classList.toggle('is-paused', this.paused);
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.abort?.abort();
      this.abort = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
